// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qf_a bhc_rq bhc_kr bhc_ks","PostDetailRight__brandDaysPosts":"qf_b bhc_rq bhc_kr bhc_ks"};